<template>
    <div class="temp-content">
        <!--查询筛选-->
        <div class="filter-wrap">
            <div class="filter-item">
                    <div class="filter-title">设施名称</div>
                    <div class="filter-element">
                        <t-input
                            placeholder="请输入设施名称"
                            :maxlength="12"
                            clearable       
                        />
                    </div>
            </div>

            <div class="filter-item">
                <div class="filter-title">设施选项</div>
                <div class="filter-element">
                    <t-input
                        placeholder="请输入设施选项"
                        :maxlength="60"
                        clearable
                    />
                </div>
            </div>

            <div class="filter-item">
                <div class="filter-title">所属设施组</div>
                <div class="filter-element">
                    <t-select
                        :options="statusType"
                        placeholder="请选择"
                        filterable
                        clearable
                        
                    />
                </div>
            </div>

            <div class="filter-item">
                <div class="filter-title">选项类型</div>
                <div class="filter-element">
                    <t-select
                        :options="statusType"
                        filterable
                        clearable
                        placeholder="请选择"
                    />
                </div>
            </div>

            <div class="filter-item">
                <div class="filter-title">填写要求</div>
                <div class="filter-element">
                    <t-select
                        :options="statusType"
                        filterable
                        clearable
                        placeholder="请选择"
                    />
                </div>
            </div>

            <div class="filter-item">
                <div class="filter-title">状态</div>
                <div class="filter-element">
                    <t-select
                        :options="statusType"
                        filterable
                        clearable
                        placeholder="请选择"
                    />
                </div>
            </div>

            <div class="filter-item">
                <div class="filter-title">修改时间</div>
                <div class="filter-element-time">
                    <t-date-range-picker
                        format="YYYY-MM-DD HH:mm"
                        :enableTimePicker="true"
                        :placeholder="['开始时间', '结束时间']"
                        allowInput
                        clearable
                        
                    />
                </div>
            </div>

            <div class="filter-item">
                <div class="filter-title">修改人</div>
                <div class="filter-element">
                    <t-input
                        placeholder="请输入修改人"
                        :maxlength="32"
                        clearable  
                    />
                </div>
            </div>

            <div class="filter-button">
                <t-button>查询</t-button>
                <t-button variant="outline">重置</t-button>
                <t-button variant="outline">导出</t-button>
            </div>
        </div>

        <!--操作按钮-->
        <div  class="action-button">
            <t-button theme="primary" @click="addClick">
                <template #icon><add-icon/></template>
                新增
            </t-button>
        </div>

        <!--列表区域-->
        <t-table
            :data="data" 
            :columns="columns"
            tableLayout="fixed"
            :show-header="true"
            cell-empty-content="--"
            row-key="index"
            resizable
            lazy-load
            size="large"
            bordered
            hover
            @drag-sort="onDragSort"
            drag-sort="row-handler"
        >
            <template #drag>
                <span><MoveIcon /></span>
            </template>
            
            <!--排序序号-->
            <template #orderNumber="{ rowIndex }">
                {{ rowIndex + 1 }}
            </template>

            <!--启用状态-->
            <template #isActive="{ row }">
                <span :class="{ 'status-inactive': row.isActive === '已停用' }">
                    {{ row.isActive }}
                </span>
            </template>

            <!--设施名称-->
            <template #facilityTitle="{ row }">
                <div class="facility-itle-item"> 
                    <img class="facility-image" :src="row.facilityImage" alt="" />
                    <span class="facility-text">{{ row.facilityTitle }}</span>
                </div>
            </template>

            <!--操作按钮-->
            <template #action="{ row }">
                <div class="table-action-button">
                    <t-link
                        class="edit-action"
                        theme="primary"
                        hover="color"
                        @click="editClick(row)"
                    >
                        编辑
                    </t-link>

                    <t-link
                        class="status-action"
                        theme='primary'
                        hover="color"
                        @click="switchStatus(row)"
                    >
                        {{ row.isActive === '已启用' ? '停用' : '启用' }}
                    </t-link>

                    <t-link
                        v-if="row.isActive === '已停用'"
                        class="delete-action"
                        theme="danger"
                        hover="color"
                        @click="deleteItem(row)"
                    >
                        删除
                    </t-link>
                </div>
            </template>
        </t-table>

        <!--抽屉-新增设施-->
        <t-drawer
            v-model:visible="visible"
            header="新增设施" 
            size="800px"
        >
            <div class="form-wrap">
                <!--设施名称-->
                <div class="form-item">
                    <div class="form-item-title"> 设施名称</div>
                    <div class="form-element">
                        <t-input
                            v-model="formData.title"
                            placeholder="请输入设施名称"
                            :maxlength="12"
                            show-limit-number
                            clearable
                            size="large"
                            />
                    </div>
                </div>

                <!-- 设施图片 -->
                <div class="form-item">
                    <div class="form-item-title">设施图片</div>
                    <div class="form-element">
                        <t-upload
                            v-model="formData.image"
                            theme="image"
                            accept="image/*"
                            :auto-upload="false"
                            :max="1"
                            :showUploadProgress="true"
                            :show-image-file-name="false" 
                            tips="建议尺寸120px*120px，最大不超过100k"
                            @success="onUploadSuccess"
                            @fail="onUploadFail"
                            :beforeUpload="beforeUpload"
                        />
                    </div>
                </div>



                <!--设施组-->
                <div class="form-item">
                    <div class="form-item-title">设施组</div>
                    <div class="form-element">
                            <t-select
                                v-model="formData.group"
                                :options="groupOption"
                                filterable
                                clearable
                                placeholder="请选择"
                                size="large"
                            />                  
                    </div>
                </div>


                
                <!--设施选项-->
                <div class="special-form-item">
                        <div class="form-item-title">设施选项</div>
                        <div>
                            <t-form-item                       
                                v-for="(item, index) in addlist"
                                :key="item.id"
                            >
                                <div class="form-element">
                                    <t-input
                                        v-model="formData.options[index]"
                                        placeholder="请输入设施选项"
                                        :maxlength="12"
                                        show-limit-number
                                        clearable
                                        size="large"
                                    />
                                </div>
                                <template #statusIcon>
                                    <t-button
                                        v-if="index === addlist.length - 1"
                                        class="drawerAddButton"
                                        variant="dashed"
                                        @click="addItem"
                                    >
                                        <t-icon name="add" />
                                    </t-button>

                                    <t-button
                                        v-if="addlist.length > 1"
                                        @click="removeItem(item, index)"
                                        class="drawerRemoveButton"
                                        variant="dashed"
                                    >
                                        <t-icon name="remove" />
                                    </t-button>
                                </template>
                            </t-form-item>
                        </div>
                </div>

                <!--填写类型-->
                <div class="form-item">
                    <div class="form-item-title">填写类型</div>
                    <div class="form-element">
                            <t-radio-group
                                v-model="formData.option_type"
                                class="drawer-radio-group"
                            >
                                <t-radio value="1">单选</t-radio>
                                <t-radio value="2">多选</t-radio>
                            </t-radio-group>                  
                    </div>
                </div>

                <!--设施说明-->
                <div class="form-item">
                    <div class="form-item-title">设施说明</div>
                    <div class="form-element">
                            <t-radio-group
                                class="drawer-radio-group"
                                v-model="formData.is_desc"
                            >
                            <t-radio :value="true">需要</t-radio>
                            <t-radio :value="false">不需要</t-radio>
                        </t-radio-group>                     
                    </div>
                </div>

                <!--填写要求-->
                <div class="form-item">
                    <div class="form-item-title">填写要求</div>
                    <div class="form-element">
                            <t-radio-group
                                class="drawer-radio-group"
                                v-model="formData.is_required"
                                >
                                <t-radio :value="true">必填</t-radio>
                                <t-radio :value="false">选填</t-radio>
                            </t-radio-group>                   
                    </div>
                </div>

                <!--排序-->
                <div class="form-item">
                    <div class="form-item-title">排序</div>
                    <div class="NumberFormElement">
                        <t-input-number
                            v-model="formData.order"
                            :max="9999"
                            :min="1"
                            size="large" 
                        />             
                    </div>
                </div>
            </div>
            <template #footer>
                    <t-button theme="primary" @click="submitForm">确定</t-button>
                    <t-button theme="default" @click="closeDrawer">取消</t-button>
            </template>
        </t-drawer>

        <!--抽屉-编辑设施-->
        <t-drawer
            v-model:visible="editVisible"
            header="编辑设施" 
            size="800px"
        >
            <div class="form-wrap">
                <!--设施名称-->
                <div class="form-item">
                    <div class="form-item-title"> 设施名称</div>
                    <div class="form-element">
                        <t-input
                            v-model="editFormData.title"
                            placeholder="请输入设施名称"
                            :maxlength="12"
                            show-limit-number
                            clearable
                            size="large"
                            />
                    </div>
                </div>

                <!-- 设施图片 -->
                <div class="form-item">
                    <div class="form-item-title">设施图片</div>
                    <div class="form-element">
                        <t-upload
                            v-model="editFormData.image"
                            theme="image"
                            accept="image/*"
                            :auto-upload="false"
                            :max="1"
                            :showUploadProgress="true"
                            :show-image-file-name="false" 
                            tips="建议尺寸120px*120px，最大不超过100k"
                            @success="(res, file) => onUploadSuccess(res, file, 'edit')"
                            @fail="(res, file) => onUploadFail(res, file, 'edit')"
                            :beforeUpload="beforeUpload"
                        />
                    </div>
                </div>

                <!--设施组-->
                <div class="form-item">
                    <div class="form-item-title">设施组</div>
                    <div class="form-element">
                            <t-select
                                v-model="editFormData.group"
                                :options="groupOption"
                                filterable
                                clearable
                                placeholder="请选择"
                                size="large"
                            />                  
                    </div>
                </div>
               
                <!--设施选项-->
                <div class="special-form-item">
                        <div class="form-item-title">设施选项</div>
                        <div>
                            <t-form-item                       
                                v-for="(item, index) in addlist"
                                :key="item.id"
                            >
                                <div class="form-element">
                                    <t-input
                                        v-model="editFormData.options[index]"
                                        placeholder="请输入设施选项"
                                        :maxlength="12"
                                        show-limit-number
                                        clearable
                                        size="large"
                                    />
                                </div>
                                <template #statusIcon>
                                    <t-button
                                        v-if="index === addlist.length - 1"
                                        class="drawerAddButton"
                                        variant="dashed"
                                        @click="addItem"
                                    >
                                        <t-icon name="add" />
                                    </t-button>

                                    <t-button
                                        v-if="addlist.length > 1"
                                        @click="removeItem(item, index)"
                                        class="drawerRemoveButton"
                                        variant="dashed"
                                    >
                                        <t-icon name="remove" />
                                    </t-button>
                                </template>
                            </t-form-item>
                        </div>
                </div>

                <!--填写类型-->
                <div class="form-item">
                    <div class="form-item-title">填写类型</div>
                    <div class="form-element">
                            <t-radio-group
                                v-model="editFormData.option_type"
                                class="radioGroup"
                            >
                                <t-radio value="1">单选</t-radio>
                                <t-radio value="2">多选</t-radio>
                            </t-radio-group>                  
                    </div>
                </div>

                <!--设施说明-->
                <div class="form-item">
                    <div class="form-item-title">设施说明</div>
                    <div class="form-element">
                            <t-radio-group
                                class="radioGroup"
                                v-model="editFormData.is_desc"
                            >
                            <t-radio :value="true">需要</t-radio>
                            <t-radio :value="false">不需要</t-radio>
                        </t-radio-group>                     
                    </div>
                </div>

                <!--填写要求-->
                <div class="form-item">
                    <div class="form-item-title">填写要求</div>
                    <div class="form-element">
                            <t-radio-group
                                class="radioGroup"
                                v-model="editFormData.is_required"
                                >
                                <t-radio :value="true">必填</t-radio>
                                <t-radio :value="false">选填</t-radio>
                            </t-radio-group>                   
                    </div>
                </div>

                <!--排序-->
                <div class="form-item">
                    <div class="form-item-title">排序</div>
                    <div class="NumberFormElement">
                        <t-input-number
                            v-model="editFormData.order"
                            :max="9999"
                            :min="1"
                            size="large" 
                        />             
                    </div>
                </div>

                <!--启用状态-->
                <div class="form-item">
                    <div class="form-item-title">启用状态</div>
                    <div class="form-element">
                            <t-radio-group
                                v-model="editFormData.is_active"
                                class="radioGroup"
                            >
                                <t-radio :value="true">启用</t-radio>
                                <t-radio :value="false">停用</t-radio>
                            </t-radio-group>                   
                    </div>
                </div>

            </div>
            <template #footer>
                    <t-button theme="primary" @click="submitEditForm">确定</t-button>
                    <t-button theme="default" @click="closeEditDrawer">取消</t-button>
            </template>
        </t-drawer>
        
    </div>
</template>

<script setup lang="jsx">
    import { AddIcon,MoveIcon } from 'tdesign-icons-vue-next';
    import { ref,computed,onMounted,reactive } from 'vue';
    import { facilityServer } from '../../../api/facility-api';
    import { formatTime } from '../../../utils/datetime';
    import { MessagePlugin,DialogPlugin  } from 'tdesign-vue-next';
   

    /**
     * 表格字段定义
     */
    const columns=ref([
        { colKey: 'drag',title: '',width:'50',},
        { colKey: 'orderNumber', title: '序号',width:'70',},
        { colKey: 'facilityTitle', title: '设施名称'},
        { colKey: 'facilityOption', title: '设施选项'},
        { colKey: 'optionType', title: '填写类型', width: 100},
        { colKey: 'isRequired', title: '填写要求', width: 100},
        { colKey: 'facilityGroup', title: '所属设施组', width: 120},
        { colKey: 'isDesc', title: '说明', width: 100},
        { colKey: 'isActive', title: '状态', cell: 'isActive', width: 100,},
        { colKey: 'updateTime', title: '修改时间' , width: 180},
        { colKey: 'updateBy', title: '修改人' , width: 120},
        { colKey: 'action', title: '操作', width: 160,},
    ]);

    /**
     * 初始化数据
     */
    //初始化设施数据
    const campData = ref([]);
    //抽屉可见状态
    const visible= ref(false); 

    /**
     * 获取设施列表
     */
    const getFacility=async()=>{
        try{
            const response = await facilityServer.getFacility();
            campData.value=response.data.map((item, index)=>({
            ...item,
            id: item.id,
            orderNumber: index+1,
            facilityImage: item.image,
            facilityTitle: item.title,
            facilityOption: item.options,
            optionType: item.option_type === '2' ? '多选' : '单选', 
            facilityGroup: item.group_name,
            isDesc:item.is_desc?'需要':'不需要',
            isRequired: item.is_required ? '必填' : '选填',
            isActive: item.is_active ? '已启用' : '已停用',
            updateTime: formatTime(item.updated_time),
            updateBy: item.updated_by,
            }));
        } catch (error) {
            console.error('获取设施列表失败:', error);
            MessagePlugin.error('获取设施列表失败，请重试');
        }
    };

    /**
     * 修改设施状态
     */
    const switchStatus = (row) => {
        const newStatus = row.isActive === '已停用';
        const actionText = newStatus ? '启用' : '停用';

        const dialog = DialogPlugin.confirm({
            header: '提示',
            body: `确定${actionText}设施 "${row.facilityTitle}" 吗？`,
            confirmBtn: '确定',
            cancelBtn: '取消',
            onConfirm: async () => {
                try {
                    // 调用 API 更新设施状态
                    await facilityServer.updateFacilityStatus(row.id, newStatus);
                    
                    // 更新本地数据
                    row.isActive = newStatus ? '已启用' : '已停用';

                    // 强制更新视图
                    campData.value = [...campData.value];
                    dialog.destroy();
                    MessagePlugin.success(`设施已${actionText}`);
                    } catch (error) {
                        console.error('修改状态失败:', error);
                        MessagePlugin.error(`${actionText}失败，请重试`);
                    }
                },
            });
    };
    
    /**
     * 删除设施
     */
    const deleteItem = (row) => {
        const dialog=DialogPlugin.confirm({
            header: '提示',
            body: `确定要删除设施 "${row.facilityTitle}" 吗？`,
            confirmBtn: '确定',
            cancelBtn: '取消',
            onConfirm: async () => {
                try {
                    await facilityServer.deleteFacilityById(row.id);
                    MessagePlugin.success('设施删除成功');
                    dialog.destroy();
                    await getFacility(); 
                } catch (error) {
                    console.error('删除设施失败:', error);
                    MessagePlugin.error('删除设施失败，请重试');
                }
            },
            onCancel: () => {
                console.log('用户取消删除操作');
            }
        });
    };

    /**
     * 组件挂载
     */    
    onMounted(() => {
        getFacility();
    });
    
    /**
     * 拖动排序
     */
    const onDragSort = async ({ newData, currentIndex, targetIndex }) => {
        try {
            campData.value = newData;

            // 更新所有行的序号
            const updatedFacilityData = campData.value.map((item, index) => ({
            id: item.id,
            order: index + 1
            }));
            const dataToSend = { orders: updatedFacilityData };

            // 调用API更新排序
            await updateFacilityOrder({ orders: updatedFacilityData });
            MessagePlugin.success('排序更新成功');
        } catch (error) {
            MessagePlugin.error(`排序更新失败: ${error.message}`);
            
            // 更新失败重新获取数据
            try {
            await getFacility();
            MessagePlugin.info('已重新加载最新设施数据');
            } catch (getFacilityError) {
            MessagePlugin.error('无法刷新数据，请刷新页面重试');
            }
        }
    };
    
    // 调用API更新设施排序
    const updateFacilityOrder = async (facilityData) => {
        console.log('发送到服务器的数据:', JSON.stringify(facilityData));
        try {
            const response = await facilityServer.updateFacilityOrder(facilityData);
            console.log('API 响应:', response);
            if (response.status !== 200) {
            throw new Error('API 请求失败');
            }
            return response.data;
        } catch (error) {
            console.error('API调用失败:', error);
            throw error;
        }
    };
    // 计算属性：返回当前的设施数据
    const data = computed(() => campData.value);
    

    
    

    /**获取最大序号 */
    const getMaxOrder = () => {
        return Math.max(...campData.value.map(item => item.order), 0);
    };

    /**
     * 新增按钮点击
     */
    const addClick=()=>{
        maxOrder.value = getMaxOrder();
        formData.order = maxOrder.value + 1;
        visible.value = true;
    };

    /**
     * 新增设施抽屉
     */
    const maxOrder=ref(0);
    const formData=reactive({
        id: '',
        title: '',
        image: [],
        options: [],
        option_type: '1',
        group: '',
        is_desc: false,
        is_required: false,
        order: 0, 
    });

    /**
     * 获取设施组选项 
     */
    const facilityGroup = ref([]);
    const getFacilityGroup = async () => {
        try {
            const response = await facilityServer.getFacilityGroup();
            facilityGroup.value = response.data.map(group => ({
                label: group.name,
                value: group.id.toString()
            }));
        } catch (error) {
            console.error('获取设施选项组失败:', error);
            MessagePlugin.error('获取设施选项组失败，请重试');
        }
    };

    onMounted(async () => {
        await getFacility();
        await getFacilityGroup();
    });

    // 计算属性：返回设施组选项
    const groupOption = computed(() => facilityGroup.value);

    /**
     * 图片上传处理
     */
    // 图片上传前的验证
    const beforeUpload = (file) => {
        const isImage = file.type.startsWith('image/');
        const isLt100k = file.size / 1024 < 100;

        if (!isImage) {
            MessagePlugin.error('仅支持上传图片文件');
            return false;
        }
        if (!isLt100k) {
            MessagePlugin.error('图片大小不能超过100k');
            return false;
        }
        return true;
    };

    // 图片上传成功处理
    const onUploadSuccess = (response, file) => {
        const imageUrl = response.url || file.url;
        if (imageUrl) {
            formData.image = [{ url: imageUrl, raw: file.raw, name: file.name }];
            console.log('Image uploaded successfully:', formData.image);
            MessagePlugin.success('图片上传成功');
        } else {
            console.error('无法获取上传图片的URL', response, file);
            MessagePlugin.error('图片上传失败，请重试');
        }
    };
    // 图片上传失败处理
    const onUploadFail = (response, file, type = 'add') => {
        console.error('图片上传失败:', response);
        MessagePlugin.error('图片上传失败，请重试');
        if (type === 'add') {
            formData.image = [];
        } else {
            editFormData.image = [];
        }
    };

    /**
     * 提交设施表单
     */
    const submitForm = async () => {
    try {
        if (!validateForm()) { return; }
        const formDataToSend = new FormData();

        // 处理图片
        if (formData.image && formData.image.length > 0) {
            const imageFile = formData.image[0];
            console.log('Image file:', imageFile);

            if (imageFile instanceof File) {
                formDataToSend.append('image', imageFile, imageFile.name);
            } else if (imageFile.raw instanceof File) {
                formDataToSend.append('image', imageFile.raw, imageFile.raw.name);
            } else {
                throw new Error('无效的图片文件格式');
            }
        } else {
            throw new Error('请上传设施图片');
        }

        // 添加其他字段
        formDataToSend.append('title', formData.title.trim());
        // 设施组
        formDataToSend.append('group', formData.group.toString())

        const validOption = formData.options.filter(v => v && v.trim() !== '');
        formDataToSend.append('options', validOption.join(','));
        formDataToSend.append('option_type', formData.option_type.toString());
        formDataToSend.append('is_desc', formData.is_desc.toString());
        formDataToSend.append('is_required', formData.is_required.toString());
        formDataToSend.append('is_active', 'true');
        formDataToSend.append('order', formData.order.toString());

        const response = await facilityServer.addFacility(formDataToSend);
        console.log('服务器响应:', response);

        if (response.status === 201 || response.status === 200) {
            MessagePlugin.success('设施添加成功');
            closeDrawer();
            getFacility();
        } else {
            throw new Error(response.data?.message || '添加设施失败');
        }
    } catch (error) {
        console.error('错误详情:', error);
        MessagePlugin.error(`添加设施失败：${error.message}`);
    }
};
    
    /**
     * 表单验证
     */
    const validateForm = () => {
        if (!formData.title) {
            MessagePlugin.error('请输入设施名称');
            return false;
        }
        if (!formData.image || formData.image.length === 0) {
            MessagePlugin.error('请上传设施图片');
            return false;
        }
        if (formData.options.length === 0 || formData.options.every(option => option.trim() === '')) {
            MessagePlugin.error('请至少添加一个设施选项');
            return false;
        }
        if (!formData.group) {
            MessagePlugin.error('请选择设施组');
            return false;
        }
        if (!formData.option_type) {
            MessagePlugin.error('请选择选项类型');
            return false;
        }
        return true;
    };

    /**
     * 重置表单 
     */
    const resetForm = () => {
        Object.assign(formData, {
            id: '',
            title: '',
            image: [],
            options: [],
            option_type: '1',
            group: '',
            is_desc: false,
            is_required: true,
            order: maxOrder.value + 1,
        });
        addlist.value = [{ id: 0, name: 'add0' }];
    };

    /**
     * 关闭新增抽屉 
     */
    const closeDrawer = () => {
        visible.value = false;
        resetForm();
    };

    /**
     * 抽屉-设施选项 
     */

    //设施选项默认
    const addlist = ref([{ id: 0, name: 'add0' }]);

    //增加设施选项
    const addItem = () => {
        const newId = addlist.value.length;
        const newName = `add${newId}`;
        addlist.value.push({ id: newId, name: newName });
        formData.options.push('');
    };

    //拖拽设施选项事件
    const removeItem = (item, index) => {
        if (addlist.value.length > 1) {
            const item = addlist.value[index];
            formData.options.splice(index, 1);
            addlist.value.splice(index, 1);
        }
    };

    /**
     * 编辑设施
     */
    const editVisible = ref(false);
    const editFormData = reactive({...formData});

    // 编辑点击事件
    const editClick = (row) => {
        const groupId = facilityGroup.value.find(group => group.label === row.facilityGroup)?.value;
        Object.assign(editFormData, {
            id: row.id,
            title: row.facilityTitle,
            image: row.facilityImage ? [{ url: row.facilityImage }] : [],
            options: row.facilityOption.split(','),
            option_type: row.optionType === '多选' ? '2' : '1',
            group: groupId,
            is_desc: row.isDesc === '需要',
            is_required: row.isRequired === '必填',
            is_active: row.isActive === '已启用',
            order: row.order,
        });
        
        addlist.value = editFormData.options.map((_, index) => ({ id: index, name: `add${index}` }));
        
        editVisible.value = true;
    };

    // 提交编辑表单
    const submitEditForm = async () => {
    try {
        if (!validateEditForm()) { return; }
        
        console.log('Submitting edit form with data:', editFormData);

        // 创建一个新的 FormData 对象
        const formData = new FormData();
        
        // 添加所有字段到 FormData
        for (const key in editFormData) {
            if (key === 'image') {
                if (editFormData.image && editFormData.image.length > 0) {
                    const imageFile = editFormData.image[0].raw || editFormData.image[0];
                    if (imageFile instanceof File) {
                        formData.append('image', imageFile, imageFile.name);
                    } else if (typeof imageFile === 'string') {
                        formData.append('image', imageFile);
                    }
                }
            } else {
                formData.append(key, editFormData[key]);
            }
        }

        const response = await facilityServer.updateFacility(editFormData.id, formData);
        console.log('服务器响应:', response);

        MessagePlugin.success('设施更新成功');
        closeEditDrawer();
        getFacility();
    } catch (error) {
        console.error('更新设施失败:', error);
        MessagePlugin.error(`更新设施失败：${error.response?.data?.message || error.message}`);
    }
};


    // 编辑表单验证
    const validateEditForm = () => {
        if (!editFormData.title || editFormData.title.trim() === '') {
            MessagePlugin.error('请输入设施名称');
            return false;
        }
        if (!editFormData.options || editFormData.options.length === 0 || editFormData.options.every(option => !option || option.trim() === '')) {
            MessagePlugin.error('请至少添加一个设施选项');
            return false;
        }
        if (!editFormData.group) {
            MessagePlugin.error('请选择设施组');
            return false;
        }
        if (!editFormData.option_type) {
            MessagePlugin.error('请选择选项类型');
            return false;
        }
        return true;
    };

    // 关闭编辑抽屉
    const closeEditDrawer = () => {
        editVisible.value = false;
        resetForm(); // 重置表单
    };
</script>

<style scoped>
    @import "./facility-admin.css";
    @import "../../../components/style/style-content.css";
    @import "../../../components/style/style-filter.css";
    @import "../../../components/style/style-table.css";
    @import "../../../components/style/style-drawer.css";
</style>